import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Paper, BottomNavigation, BottomNavigationAction } from "@mui/material";
import { Inventory2, DeliveryDining, History } from "@mui/icons-material";

const TABS = [
  { path: "/", label: "Pickup", icon: <Inventory2 /> },
  { path: "/my-deliveries", label: "My Deliveries", icon: <DeliveryDining /> },
  { path: "/history", label: "History", icon: <History /> },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const current = TABS.find((t) => t.path === pathname)?.path || false;

  return (
    <Paper elevation={8} sx={{ position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 20 }}>
      <BottomNavigation value={current} onChange={(_, v) => navigate(v)} showLabels>
        {TABS.map((t) => (
          <BottomNavigationAction key={t.path} label={t.label} value={t.path} icon={t.icon} sx={{ minWidth: 0 }} />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
